module.exports = __webpack_public_path__ + "img/banner-placeholder.aaaacf3a.jpg";